module.exports = globalThis["jQuery"];